var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokerageBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:#49AADB;}\n\t.st5{fill:#1CA8D3;}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:#32C1ED;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 104,
    y1: 422,
    x2: 104,
    y2: 326,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0098ED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104,80c4.4,0,8,3.6,8,8h16c0-10.4-6.7-19.2-16-22.5V56H96v9.5C86.7,68.8,80,77.6,80,88c0,13.2,10.8,24,24,24 c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8H80c0,10.4,6.7,19.2,16,22.5v9.5h16v-9.5c9.3-3.3,16-12.1,16-22.5c0-13.2-10.8-24-24-24 c-4.4,0-8-3.6-8-8S99.6,80,104,80z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.95,
    y1: 418.1,
    x2: 117.95,
    y2: 302,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009BEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104,48c30.9,0,56,25.1,56,56c0,12.5-4.1,24.4-11.8,34.3l12.6,9.8c9.9-12.8,15.2-28,15.2-44.1 c0-39.7-32.3-72-72-72c-16.1,0-31.3,5.2-44.1,15.2l9.8,12.6C79.6,52.1,91.5,48,104,48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.05,
    y1: 446,
    x2: 90.05,
    y2: 329.9,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A4EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104,176c16.1,0,31.3-5.2,44.1-15.2l-9.8-12.6c-9.9,7.7-21.8,11.8-34.3,11.8c-30.9,0-56-25.1-56-56 c0-12.5,4.1-24.4,11.8-34.3l-12.6-9.8C37.2,72.7,32,87.9,32,104C32,143.7,64.3,176,104,176z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 296,
    y1: 766,
    x2: 296,
    y2: 270,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01C5E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006DF0"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M448,144h-16V80h-16V48h-40V0h-16v48h-40v32h-16v64h-16v112h-16v-48h-16v-32h-24v-40h-16v40h-24v32h-16v48h-32 v224h-16v16h336v-16h-16V144z M336,64h64v16h-64V64z M320,96h96v48h-16v-32h-16v32h-32v-32h-16v32h-16V96z M432,160v320h-24v-80h-80 v80h-24V160H432z M392,480h-48v-64h48V480z M208,192h32v16h-32V192z M192,224h64v32h-24v-16h-16v16h-24V224z M160,272h128v208h-16 V288h-16v192h-24V288h-16v192h-24V288h-16v192h-16V272z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320,176h16v16h-16V176z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M360,176h16v16h-16V176z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400,176h16v16h-16V176z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320,224h16v16h-16V224z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M360,224h16v16h-16V224z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400,224h16v16h-16V224z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320,272h16v16h-16V272z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M360,272h16v16h-16V272z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400,272h16v16h-16V272z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320,320h16v16h-16V320z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M360,320h16v16h-16V320z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400,320h16v16h-16V320z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320,368h16v16h-16V368z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M360,368h16v16h-16V368z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400,368h16v16h-16V368z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0,240h16v16H0V240z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 8,
    y1: 638,
    x2: 8,
    y2: 542,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009DEC"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0,272h16v96H0V272z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48,296h16v16H48V296z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 56,
    y1: 694,
    x2: 56,
    y2: 598,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009DEC"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48,328h16v96H48V328z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96,240h16v16H96V240z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 104,
    y1: 638,
    x2: 104,
    y2: 542,
    gradientTransform: "matrix(1 0 0 1 0 -270)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01CAE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009DEC"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M96,272h16v96H96V272z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M480,480h16v16h-16V480z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M96,480h16v16H96V480z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerageBlue);
export default __webpack_public_path__ + "static/media/brokerage-blue.7558b358823ab843c80f199fd5d4fa71.svg";
export { ForwardRef as ReactComponent };